export const getIntercom = (): Intercom_.IntercomStatic | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }
  return window.Intercom
}
